const l=(l,e)=>{let t=null;return(...u)=>{null!==t&&(clearTimeout(t),t=null),t=setTimeout((()=>l(...u)),e)}};export{l as debounce};
//# sourceMappingURL=debounce.js.map
